export default __webpack_public_path__ + "static/media/sharon.36b57db3.png";